<template>
  <v-tab-item key="collections" value="collections">
    <div class="px-3 px-md-0">
      <h2
        class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
      >
        Collections
      </h2>
      <div class="mr-2 mt-3">
        <p>
          Explore collections curated by our team, which gather together content
          related to particular themes or topics.
        </p>
        <p>
          If you'd like to suggest a new collection, feel free to contact us at
          <strong>
            <a :href="`mailto:${contactEmailAddress}`">{{
              contactEmailAddress
            }}</a>
          </strong>
        </p>
      </div>
    </div>
    <div class="px-3 px-md-0">
      <ContainerGrid>
        <LayoutItems
          ref="collectionsRef"
          :items="collectionsToDisplay"
          component-name="CollectionOverview"
          cols="12"
          sm="6"
          md="6"
          lg="4"
        />
      </ContainerGrid>
    </div>

    <div
      v-if="isCollectionsExceededLimit && showLimitedCollections"
      class="text-center"
    >
      <v-btn
        :aria-label="ariaLabel"
        outlined
        rounded
        @click="showAllCollections"
      >
        View All
        <span class="d-sr-only"
          >&nbsp;collections for community {{ community.name }}</span
        >
      </v-btn>
    </div>
  </v-tab-item>
</template>

<script>
import { mapState } from "vuex";

import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";

export default {
  name: "CommunityCollectionsTab",
  components: {
    ContainerGrid,
    LayoutItems,
  },
  props: {
    collections: { type: Array, required: true },
    collectionsCount: { type: Number, required: true },
    collectionsLimit: { type: Number, required: true },
    community: { type: Object, required: true },
  },
  data() {
    return {
      ariaLabel: `View All Collections for ${this.community.name} Community`,
      showLimitedCollections: true,
      contactEmailAddress: "cambridgeopenengage@cambridge.org",
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.isLoading,
    }),
    partner() {
      return this.$config.partner;
    },
    isCollectionsExceededLimit() {
      return this.collectionsCount > this.collectionsLimit;
    },
    collectionsToDisplay() {
      const limitedCollections = this.collections.slice(
        0,
        this.collectionsLimit
      );
      return this.showLimitedCollections
        ? limitedCollections
        : this.collections;
    },
  },
  methods: {
    async showAllCollections() {
      if (this.isLoading) {
        return;
      }

      const params = {
        communityId: this.community.id,
      };
      await this.$store.dispatch("loadAllCommunityCollectionListing", {
        params,
      });
      this.showLimitedCollections = false;

      this.$nextTick(() => {
        const index = this.collectionsLimit;
        const collectionButton =
          this.$refs.collectionsRef?.$children[index].$children[0].$children[1]
            .$el;
        collectionButton.focus();
      });
    },
  },
};
</script>
